import EditFormPage from 'modules/ui/editform/EditFormPage';
import RacsTesztlapEditService from 'app/admin/racstesztlap/service/RacsTesztlapEditService';
import ExamImageGridCornerField from 'app/admin/examImage/gridCorner/ExamImageGridCornerField';
import nBossConnection from 'modules/base/service/nBossConnection';

const config = {
	key: 'racsTesztlapEditForm',
	text: 'Rács megadása',
	textKey: 'racstesztlap',
	service: RacsTesztlapEditService,
	hideSaveButton: true,
	fields: [
		{
			key: 'elokeszitettPath',
			text: 'Előkészített',
			textKey: 'elokeszitettPath',
			component: ExamImageGridCornerField,
			imageUrl: `${nBossConnection.baseUrl}fmBrowserTableControl/getFileByPath?path=`
		}
	]
};

function RacsTesztlapEditForm() {
	return <EditFormPage config={config} />;
}

export default RacsTesztlapEditForm;
